
import { CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface RecommendedDealersFooterProps {
  selectedMetal: "gold" | "silver";
  onMetalChange: (metal: "gold" | "silver") => void;
  onViewAllClick?: () => void; // Manteniamo questo per compatibilità
  onMouseEnter?: () => void;
}

export function RecommendedDealersFooter({ 
  selectedMetal, 
  onMetalChange,
  onViewAllClick,
  onMouseEnter
}: RecommendedDealersFooterProps) {
  return (
    <CardFooter className="flex items-center justify-between py-4 border-t">
      <Tabs 
        value={selectedMetal} 
        onValueChange={(value) => onMetalChange(value as "gold" | "silver")}
      >
        <TabsList className="h-8">
          <TabsTrigger value="gold" className="text-xs h-7">Oro</TabsTrigger>
          <TabsTrigger value="silver" className="text-xs h-7">Argento</TabsTrigger>
        </TabsList>
      </Tabs>
      
      <Button 
        size="sm" 
        className="h-8 metal-accent"
        onMouseEnter={onMouseEnter}
        asChild
      >
        <Link to="/compro-oro">
          Vedi Tutti <ArrowRight className="h-3 w-3 ml-1" />
        </Link>
      </Button>
    </CardFooter>
  );
}
